
import React from "react";

const CardJSX = (link: any, destination: any) => {
    return {
        data: {
            ressource: '',
            dontStatus: true,
            img: '',
            status: 'visible',
            statusActive: '',
            statusDeactive: '',
            link: 'translation.de.slug',
            prelink: link + '/magazin/[param]/',
            prelinksearch: 'translation.de.slug',
            title: 'token',
            descriptionShow: true,
            description: 'refferal_date',
            router: 'id',
            showreferer: true,
            referer_label: 'Partner',
            referer_firstname: 'referer.customer.firstName',
            referer_lastname: 'referer.customer.lastName',
            refer_user_label: 'Mandant',
            referer_user_firstname: 'user.customer.firstName',
            referer_user_lastname: 'user.customer.lastName',
            preroute: '/' + destination + '/Detail/',
            edit: '',
            delete: true,
            Dontvisited: true,
            deleteLink: '',
            // Added Button Conditions
            addedButtonLink:'',
            addedButtonText:(<><span className="material-icons">print</span></>),
            addedButton: true,
            addedButtonOnClick: setOnClick,
            addedButtonSetLink: true
        }
    }
}

export default CardJSX


const setOnClick = () => {

    alert('test');

}

